import { render, staticRenderFns } from "./singleImage.vue?vue&type=template&id=317aae3e"
import script from "./singleImage.vue?vue&type=script&lang=js"
export * from "./singleImage.vue?vue&type=script&lang=js"
import style0 from "./singleImage.vue?vue&type=style&index=0&id=317aae3e&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports